import { createSlice } from '@reduxjs/toolkit';

export const paging = createSlice({
  name: 'PAGING',
  initialState: {}, // a required field, but overwritten by preloadedState in store

  reducers: {
    update(_state, action) {
      return action.payload;
    },
  },
});

const { actions, reducer } = paging;

export const { update } = actions;

export default reducer;
